<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div
    ref="triggerElement"
    class="h-full"
    @mouseenter="showMenu"
    @mouseleave="hideMenu"
    @keydown.escape="hideMenu"
  >
    <slot name="trigger" :isOpen :isMenuActive :showMenu :hideMenu />

    <div class="absolute inset-x-0 z-[1] mt-1">
      <Transition
        :css="withTransition"
        enter-active-class="ease-out duration-300"
        enter-from-class="[clip-path:inset(0_0_100%)]"
        enter-to-class="[clip-path:inset(0_0_0%)]"
        leave-active-class="ease-in duration-100"
        leave-from-class="[clip-path:inset(0_0_0%)]"
        leave-to-class="[clip-path:inset(0_0_100%)]"
        @after-enter="withTransition = false"
      >
        <div
          v-show="isOpen"
          :id="`submenu-${id}`"
          class="bg-surface-default-low transition-[clip-path]"
          role="menu"
        >
          <slot name="panel" :hideMenu />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef, watch } from 'vue'

import { useNavDropdown } from '../../composables/useNavDropdown'

const props = defineProps<{
  id: string
  onShow?: () => void
}>()

const emit = defineEmits<{
  focus: []
  blur: []
}>()

const triggerElement = useTemplateRef<HTMLElement>('triggerElement')

const { isOpen, isMenuActive, showMenu, hideMenu, withTransition, focused } =
  useNavDropdown(props.id, triggerElement, props.onShow)

watch(focused, (isFocused) => {
  if (isFocused) {
    emit('focus')
  } else {
    emit('blur')
  }
})
</script>
